// extracted by mini-css-extract-plugin
module.exports = {"center":"_f211948","thumbnail":"_438370c"};